module.exports = __webpack_public_path__ + "static/media/Coil-SingleLayer.a32b5743.png";